import { WindowSearch, WindowPost, WindowPut } from '../interfaces/Window'
import { getUrlMvmApi } from '../utils/util';
import ApiHandler from './ApiHandler';

export const baseURL = String(getUrlMvmApi(window));

export default class WindowApi {
    static async searchWindow(params: WindowSearch) {
        //delete array null properties
        if (params.suppliersId === "")
            delete params.suppliersId;

        var response = await ApiHandler(baseURL).get('Window/search', { params });
        return response.data;
    }

    static async delete(id: number) {
        var response = await ApiHandler(baseURL).delete(`Window/${id}`);
        return response.data;
    }

    static async get(id: number) {
        var response = await ApiHandler(baseURL).get(`Window/${id}`);
        return response.data;
    }

    static async post(data: WindowPost) {
        var response = await ApiHandler(baseURL).post('Window', data);
        return response.data;
    }

    static async put(data: WindowPut) {
        var response = await ApiHandler(baseURL).put('Window', data);
        return response.data;
    }

}
